import React, {useRef} from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faPrint, faTimes } from '@fortawesome/free-solid-svg-icons';
import { useAuth } from '../hooks/useAuth';
import '../styles/ViewModal.css';
import axios from 'axios';


const handleDownload = async (filePath) => {
    try {
      // Make a GET request to the download endpoint with Axios
      const response = await axios.get(`${process.env.REACT_APP_SERVER_BASE_URL}/hospital-portal/api/documents/download`, {
        params: { filePath }, 
        responseType: 'blob', // ensures the response is treated as a file (binary data)
      });
  
      const fileName = filePath.split('/').pop();
  
      // Create a URL for the file and trigger a download
      const blob = new Blob([response.data], { type: response.headers['content-type'] });
      const blobUrl = window.URL.createObjectURL(blob);

      // Open the Blob URL in a new tab
      window.open(blobUrl, '_blank');
  
      // Clean up the object URL
      window.URL.revokeObjectURL(blobUrl);

    } catch (error) {
      console.error('Error downloading file:', error);
      alert('Failed to download file. Please try again.');
    }
  };

const ViewModal = ({ record, onClose, onEdit, apiConfig,editable }) => {
  const { user, hasPermission } = useAuth();
  const modalRef = useRef(null);

  if (!record) return null;

  const canAccessTab = (tabConfig) => {
    // Priority 1: Check for backwards compatibility with roles
    if (tabConfig.roles) {
      if (tabConfig.roles === 'all') {
        return true; // Bypass security check for "all"
      }
      const allowedRoles = tabConfig.roles.split(',').map((role) => role.trim());
      return allowedRoles.includes(user?.role);
    }
    
    // Priority 2: Check securityPath if no roles specified
    if (tabConfig.securityPath) {
      return hasPermission(tabConfig.securityPath, tabConfig.permission || 'View');
    }
    
    // Default: Allow access if neither roles nor securityPath specified
    return true;
  };
  const handlePrint = () => {
    window.print();
  };

  const sections = apiConfig.tabs?.length
    ? apiConfig.tabs
    : [{ name: '__all__', label: null }];

  return (
    <div className="view-modal">
      <div className="view-modal-content">
      <div className="view-modal-actions">
          {editable && (
            <button
              className="view-modal-edit-button"
              onClick={() => {
                onClose();
                onEdit(record);
              }}
            >
              <FontAwesomeIcon icon={faEdit} /> Edit
            </button>
          )}
          <button
            className="view-modal-print-button"
            onClick={handlePrint}
          >
            <FontAwesomeIcon icon={faPrint} /> Print
          </button>
          <button className="view-modal-close-button" onClick={onClose}>
            <FontAwesomeIcon icon={faTimes} /> Close
          </button>
        </div>
        <h2>View {apiConfig.title}</h2>
        <div className="view-modal-details">
          {sections.map((tab) => (
            canAccessTab(tab) && (
              <div key={tab.name} className="view-modal-section">
                {tab.label ? <h3>{tab.label || tab.name}</h3> : null}
                {apiConfig.fields
                  .filter((field) => (
                    (field.viewable ?? true)
                    && field.visible !== false
                    && (!apiConfig.tabs?.length || field.tab === tab.name)
                  ))
                  .map((field) => (
                    <div key={field.name} className="view-modal-field">
                      <strong>{field.label || field.name}:</strong> 
                      { field.type === 'file' && record[field.name]?.split('/').pop() ? (
                        <button type="button" onClick={() => handleDownload(`${record[field.name]}`)}>
                             {record[field.name].split('/').pop().length > 30 
                             ? `${record[field.name].split('/').pop().slice(0, 30)}...` 
                             : record[field.name].split('/').pop()}
                        </button>
                      ): field.type === 'advanced-array' ? (
                        <table>
                          <thead>
                            <tr>
                              <th>Name</th>
                              {field.additionalFields?.map((additionalField) => (
                                <th key={additionalField.name}>{additionalField.label}</th>
                              ))}
                            </tr>
                          </thead>
                          <tbody>
                            {record[field.name]?.map((item, index) => (
                              <tr key={index}>
                                <td>{item.name}</td>
                                {field.additionalFields.map((additionalField) => (
                                  <td key={additionalField.name}>
                                    {item[additionalField.name]}
                                  </td>
                                ))}
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      ) : field.type === 'subform' ? (
                        <table>
                          <thead>
                            <tr>
                              {record[field.name] && record[field.name].length > 0 && 
                                Object.keys(record[field.name][0]).map((key) => (
                                  <th key={key}>{key}</th>
                                ))}
                            </tr>
                          </thead>
                          <tbody>
                            {record[field.name]?.map((item, index) => (
                              <tr key={index}>
                                {Object.keys(item).map((key) => (
                                  <td key={key}>
                                    {item[key]}
                                  </td>
                                ))}
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      ) : field.type === 'dropdown' ? (
                        record[field.name]
                      ) : field.type === 'checkbox' ? (
                        <span>{record[field.name] ? 'Yes' : 'No'}</span>
                      ) : (
                        <span>
                        {field.allowJson === true
                            ? JSON.stringify(record[field.name], '', 2) // Format the JSON for readability
                            : (record[field.name]===null || record[field.name]===undefined ? '' : String(record[field.name]))}
                        </span>
                      )}
                    </div>
                  ))}
              </div>
            )
          ))}
        </div>
 
      </div>
    </div>
   

  );
};

export default ViewModal;
